import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { CustomDialogComponentName } from '@/store/modules/dialog/dialogTypes'

interface DialogStyles {
  maxWidth?: string
  minHeight?: string
  maxHeight?: string
  width?: string
  height?: string
  [key: string]: string | undefined
}

interface CustomDialogComposable {
  showCustomDialog: (name: CustomDialogComponentName, styles?: DialogStyles, props?: any) => Promise<any>
}

export default function useCustomDialog(): CustomDialogComposable {
  const dialogModule = ModuleNamespaces.DIALOG

  const showCustomDialog = async (
    name: CustomDialogComponentName,
    styles?: DialogStyles,
    props?: any
  ): Promise<any> => {
    // console.log('Showing custom dialog with props:', name, styles, props)
    return store.dispatch(`${dialogModule}/showCustomDialog`, {
      name,
      styles,
      props
    })
  }

  return {
    showCustomDialog
  }
}
